/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    role: 'utente',
    numeric_role: 2
  },
  // {
  //   url: "/todo",
  //   name: "To Do",
  //   slug: "todo",
  //   icon: "CheckSquareIcon",
  //   role: 'utente',
  //   numeric_role: 2
  // },
  {
    url: "/utenti",
    name: "Utenti",
    slug: "utenti",
    icon: "UsersIcon",
    i18n: "Utenti",
    role: 'responsabile',
    numeric_role: 0
  },
  {
    url: "/aziende",
    name: "Aziende",
    slug: "aziende",
    icon: "GridIcon",
    i18n: "Aziende",
    role: 'utente',
    numeric_role: 2
  },
  {
    url: "/contatti",
    name: "Contatti",
    slug: "contatti",
    icon: "PhoneCallIcon",
    i18n: "Contatti",
    role: 'utente',
    numeric_role: 2
  },
  {
    url: "/tariffario",
    name: "Tariffario",
    slug: "tariffario",
    icon: "ListIcon",
    i18n: "Tariffario",
    role: 'utente',
    numeric_role: 2
  },
  {
    url: "/leads",
    name: "Leads",
    slug: "leads",
    icon: "ActivityIcon",
    i18n: "Leads",
    role: 'utente',
    numeric_role: 2,
    submenu: [
			{
				url: '/leads/elenco',
				name: "Elenco",
				slug: "leads-elenco",
				i18n: "elenco",
        role: 'utente',
        numeric_role: 2,
			},
			{
				url: '/leads/board',
				name: "Board",
				slug: "leads-board",
				i18n: "board",
        role: 'utente',
        numeric_role: 2,
			}
		]
  },
  {
    url: "/documenti",
    name: "Documenti",
    slug: "documenti",
    icon: "ArchiveIcon",
    i18n: "Documenti",
    role: 'utente',
    numeric_role: 2,
    submenu: [
			{
				url: '/documenti/preventivi',
				name: "Preventivi",
				slug: "documenti-preventivi",
				i18n: "Preventivi",
        role: 'utente',
        numeric_role: 2,
			},
			{
				url: '/documenti/contratti',
				name: "Contratti",
				slug: "documenti-contratti",
				i18n: "contratti",
        role: 'utente',
        numeric_role: 2,
			},
			{
				url: '/documenti/altri',
				name: "Altri",
				slug: "documenti-altri",
				i18n: "altri",
        role: 'utente',
        numeric_role: 2,
			},
		]
  },
  {
    url: "/documenti/rimborsi",
    name: "Rimborsi",
    slug: "rimborsi",
    icon: "PocketIcon",
    i18n: "Rimborsi",
    role: 'utente',
    numeric_role: 2,
  },
  {
    url: "/documenti/addebiti",
    name: "Addebiti",
    slug: "addebiti",
    icon: "AlertOctagonIcon",
    i18n: "Addebiti",
    role: 'utente',
    numeric_role: 2,
  },
  // {
  //   url: "/opportunita",
  //   name: "Opportunità",
  //   slug: "opportunita",
  //   icon: "SlackIcon",
  //   i18n: "Opportunità",
  //   role: 'utente'
  // },
  {
    url: "/attivita",
    name: "Attività",
    slug: "attività",
    icon: "CalendarIcon",
    i18n: "Attivita",
    role: 'utente',
    numeric_role: 2,
    submenu: [
      {
        url: '/attivita/elenco',
        name: "Elenco",
        slug: "attivita-elenco",
        i18n: "attivita-elenco",
        role: 'utente',
        numeric_role: 2,
      },
      {
        url: '/attivita/calendario',
        name: "Calendario",
        slug: "attivita-calendario",
        i18n: "calendario",
        role: 'utente',
        numeric_role: 2,
      }
    ]
  },
  // {
  //   url: "/attivita",
  //   name: "Attività",
  //   slug: "attivita",
  //   icon: "CalendarIcon",
  //   i18n: "Attività",
  //   role: 'utente'
  // },
  {
    name: "Tirocini",
    icon: "AwardIcon",
    role: 'utente',
    numeric_role: 2,
    submenu: [
      {
        url: '/tirocini/pratiche',
        name: "Pratiche",
        icon: "UserPlusIcon",
        role: 'utente',
        numeric_role: 2,
      },
      {
        url: '/tirocini/tutor',
        name: "Tutor",
        icon: "UserPlusIcon",
        role: 'utente',
        numeric_role: 2,
      },
    ]
  },
  {
    url: "/altro",
    name: "Altro",
    slug: "altro",
    icon: "PlusCircleIcon",
    i18n: "Altro",
    role: 'admin',
    numeric_role: 0,
    submenu: [
      {
        url: '/pacchetti',
        name: "Pacchetti",
        slug: "Pacchetti",
        icon: "BoxIcon",
        i18n: "Pacchetti",
        role: 'admin',
        numeric_role: 0,
      },
      {
        url: '/templates',
        name: "Templates",
        slug: "Templates",
        icon: "ClipboardIcon",
        i18n: "Templates",
        role: 'admin',
        numeric_role: 0,
      },
      {
        url: '/default_templates',
        name: "Default Templates",
        slug: "Default Templates",
        icon: "ClipboardIcon",
        i18n: "Default Templates",
        role: 'admin',
        numeric_role: 0,
      },
    ]
  },
  // {
  //   url: "/reports",
  //   name: "Reports",
  //   slug: "reports",
  //   icon: "BarChart2Icon",
  //   i18n: "Reports",
  //   role: 'admin',
  //   numeric_role: 0
  // },
  {
    url: "/reports/dati",
    name: "Reports",
    slug: "reports-dati",
    i18n: "reports-dati",
    icon: "BarChart2Icon",
    role: 'responsabile',
    numeric_role: 1,
  },
  // {
  //   url: "/reports",
  //   name: "Reports",
  //   slug: "reports",
  //   icon: "BarChart2Icon",
  //   i18n: "Reports",
  //   role: 'admin',
  //   numeric_role: 0,
  //   submenu: [
	// 		// {
	// 		// 	url: '/reports/mappa',
	// 		// 	name: "Mappa",
	// 		// 	slug: "reports-mappa",
	// 		// 	i18n: "reports-mappa",
  //     //   role: 'admin',
  //     //   numeric_role: 0,
	// 		// },
	// 		{
	// 			url: '/reports/dati',
	// 			name: "Pivot",
	// 			slug: "reports-dati",
	// 			i18n: "reports-dati",
  //       role: 'admin',
  //       numeric_role: 0,
	// 		},
	// 		// {
	// 		// 	url: '/reports/dati-benchmark',
	// 		// 	name: "Pivot Benchmark",
	// 		// 	slug: "reports-dati-benchmark",
	// 		// 	i18n: "reports-dati-benchmark",
  //     //   role: 'admin',
  //     //   numeric_role: 0,
	// 		// },
	// 		// {
	// 		// 	url: '/reports/stats',
	// 		// 	name: "Statistiche",
	// 		// 	slug: "reports-stats",
	// 		// 	i18n: "reports-stats",
  //     //   role: 'admin',
  //     //   numeric_role: 0,
	// 		// }
	// 	]
  // },
]
